import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AiCrudViewComponent } from '../ai-crud-view/ai-crud-view.component';
import { EntityService } from '../../services/entity.service';
import { AI_FUNCTION_CALL_ENTITY_META_CONFIG } from '../../configs/ai-function-calls.entity.config';
import { EntityConfigInterface } from 'libs/components/src/lib/components/crud-view';
import { BrowserStorageManagementService } from 'libs/shared/src/lib/services/browser-storage-management-service/browser-storage-management.service';

@Component({
  selector: 'rappider-ai-function-calls',
  standalone: true,
  imports: [
    CommonModule,
    AiCrudViewComponent
  ],
  templateUrl: './ai-function-calls.component.html',
  styleUrls: ['./ai-function-calls.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiFunctionCallsComponent implements OnInit {

  entityConfig: EntityConfigInterface | undefined;
  entityConfigs: { [key: string]: EntityConfigInterface } = {};
  entityData: Record<string, any> = {};
  activeEntityItem: any;
  defaultEntityName = 'AiFunctionCall';

  constructor(
    private entityService: EntityService,
    private browserStorageManagementService: BrowserStorageManagementService
  ) { }

  ngOnInit() {
    this.entityConfig = this.entityService.generateEntityConfig(AI_FUNCTION_CALL_ENTITY_META_CONFIG);
    this.entityConfigs[this.defaultEntityName] = this.entityConfig;
    console.log('Active Entity Config:', this.entityConfig);
  }

  onEntitySelected(entity: any) {
    console.log('Selected Entity Config:', entity);
  }
  onEntityItemSelected(item: any) {
    this.activeEntityItem = item;
    console.log('Selected Entity Item:', item);
  }

  onJoyrideDoneButtonClick(){
    this.browserStorageManagementService.setLocalStorageItem('tour', 'stop');
  }
}
